<template>
    <div>
      <div class="laypanel" style="margin: 40px;">
        <div class="querypanel">
          <el-row>
            <el-form ref="form"  label-width="120px" label-position="left">
            <el-col :span="12">
              <el-form-item label="广告选择:">
                  <el-select v-model="gginfo" filterable clearable placeholder="请选择广告" @change="selectgg">
                    <el-option
                      v-for="item in gglist"
                      :key="item.APP_ID"
                      :label="item.APP_NAME"
                      :value="item.APP_ID"
                    >
                      <span style="float: left">{{ item.APP_NAME }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.APP_ID }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-col>
              <el-col :span="12">
                <el-form-item label="渠道选择:">
                  <el-select v-model="qdinfo" filterable clearable placeholder="请选择渠道">
                    <el-option
                      v-for="item in qdlist"
                      :key="item.COMPANY_KEY"
                      :label="item.NAME"
                      :value="item.COMPANY_KEY"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            <el-col :span="12">
              <el-form-item label="日期:">
                <el-date-picker
                  v-model="byorderdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序:">
                <el-switch
                  v-model="px"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="正向"
                  inactive-text="逆向">
                </el-switch>
              </el-form-item>
            </el-col>
              <el-col :span="24">
                <el-form ref="form"  label-width="120px" label-position="left">
                  <el-form-item label="IDFA">
                    <el-input v-model="idfa"></el-input>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="12">
                <el-form-item label="数据:">
                  <el-switch
                    v-model="dataway"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="9月29后"
                    inactive-text="9月29前">
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="queryclick">查看点回</el-button>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="querynewclick">查看新点回</el-button>
            </el-col>
          </el-row>
        </div>

        <el-row style="margin-top: 20px;">
          <el-col :span="24">
            <span style="color: #00a67c;margin-bottom: 20px;">点击总数(全部)：{{clickcount}}，</span>
            <span style="color: #00a67c;margin-bottom: 20px;"> 激活比率：{{jhbl}}</span>
          </el-col>
          <el-col :span="12">
            <el-table
              stripe
              v-loading="clickloading"
              :data="hddata"
              ref="multipleTable">
              <el-table-column
                prop="APP_NAME"
                label="广告">
              </el-table-column>
              <el-table-column
                prop="NAME"
                label="渠道">
              </el-table-column>
              <el-table-column
                prop="GGCOUNT"
                label="下行量(排重后)">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="4">
            <el-table
              stripe
              v-loading="clickloading"
              :data="xxhddata"
              ref="multipleTable">
              <el-table-column
                prop="GGCOUNT"
                label="下行量（全部）">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="4">
            <el-table
              stripe
              v-loading="clickloading"
              :data="pczldata"
              ref="multipleTable">
              <el-table-column
                prop="GGCOUNT"
                label="总量（排重后）">
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="4">
            <el-table
              stripe
              v-loading="clickloading"
              :data="nopczldata"
              ref="multipleTable">
              <el-table-column
                prop="GGCOUNT"
                label="总量（全部）">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'GetGGClick',
    data () {
      return {
        px: true,
        clickcount: '',
        hdcount: '',
        jhbl: '',
        gglist: [],
        gginfo: '',
        qdlist: [],
        hddata: [],
        xxhddata: [],
        pczldata: [],
        nopczldata: [],
        qdinfo: '',
        byorderdate: '',
        clickloading: false,
        dataway: true,
        clickdata: [],
        idfa: ''
      }
    },
    mounted: function () {
      that = this
      that.$options.methods.querygg()
      that.$options.methods.queryqd()
    },
    methods: {
      selectgg (value) {
        window.console.log(value)
      },
      querygg () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getads',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.gglist = res.data
            } else {
              that.gglist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryqd () {
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getchannels',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.qdlist = res.data
            } else {
              that.qdlist = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      queryclick () {
        that.$options.methods.gethddata()
        that.$options.methods.getzldata()
        that.$options.methods.getxxhddata()
        that.$options.methods.getnozldata()
        that.$options.methods.getclickcount()
      },
      querynewclick () {
        that.$options.methods.getnewhddata()
        that.$options.methods.getnewzldata()
        that.$options.methods.getnewxxhddata()
        that.$options.methods.getnewnozldata()
        that.$options.methods.getnewclickcount()
      },
      gethddata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '1'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.hddata = res.data
            } else {
              that.hddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getzldata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '2'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.pczldata = res.data
              that.hdcount = that.pczldata[0].GGCOUNT
            } else {
              that.pczldata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getxxhddata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '1'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnopcsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.xxhddata = res.data
            } else {
              that.xxhddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getnozldata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '2'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnopcsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.nopczldata = res.data
            } else {
              that.nopczldata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getclickcount() {
        if (that.dataway) {
          window.console.log('9月29日后')
          var pxstr = 'asc'
          if (that.px) {
            pxstr = 'asc'
          } else {
            pxstr = 'desc'
          }
          var startdate = ''
          if (that.byorderdate[0] !== '') {
            startdate = that.byorderdate[0]
          }
          var enddate = ''
          if (that.byorderdate[1] !== '') {
            enddate = that.byorderdate[1]
          }
          var qdinfo = ''
          if (that.qdinfo !== '') {
            qdinfo = that.qdinfo
          }
          var qdata = {
            pid: that.gginfo,
            cid: qdinfo,
            px: pxstr,
            startdate: startdate,
            enddate: enddate
          }
          that.clickcount = '查询中，请稍等'
          that.$http({
            url: 'http://api.jiyuewuxian.cn/getdjcount',
            method: 'post',
            data: qdata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              window.console.log(res)
              if (res.status === 200) {
                that.clickcount = res.data
                window.console.log(that.hdcount)
                window.console.log(that.clickcount[0].总数)
                that.jhbl = (parseInt(that.hdcount) / parseInt(that.clickcount[0].总数)).toFixed(2)
              } else {
                that.clickcount = '查询失败'
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        } else {
          window.console.log('9月29日前')
          var pxstr1 = 'asc'
          if (that.px) {
            pxstr1 = 'asc'
          } else {
            pxstr1 = 'desc'
          }
          var startdate1 = ''
          if (that.byorderdate[0] !== '') {
            startdate1 = that.byorderdate[0]
          }
          var enddate1 = ''
          if (that.byorderdate[1] !== '') {
            enddate1 = that.byorderdate[1]
          }
          var qdinfo1 = ''
          if (that.qdinfo !== '') {
            qdinfo1 = that.qdinfo
          }
          var qdata1 = {
            pid: that.gginfo,
            cid: qdinfo1,
            px: pxstr1,
            startdate: startdate1,
            enddate: enddate1
          }
          that.clickcount = '查询中，请稍等'
          that.$http({
            url: 'http://api.jiyuewuxian.cn/getolddjcount',
            method: 'post',
            data: qdata1,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              window.console.log(res)
              if (res.status === 200) {
                that.clickcount = res.data
                that.jhbl = that.hdcount / that.clickcount
              } else {
                that.clickcount = '查询失败'
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      getnewhddata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '1'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.hddata = res.data
            } else {
              that.hddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getnewzldata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '2'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.pczldata = res.data
              that.hdcount = that.pczldata[0].GGCOUNT
            } else {
              that.pczldata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getnewxxhddata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '1'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewnopcsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.xxhddata = res.data
            } else {
              that.xxhddata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getnewnozldata () {
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          startdate: startdate,
          enddate: enddate,
          flag: '2'
        }
        that.clickloading = true
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewnopcsingleqdjh',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.clickloading = false
            if (res.status === 200) {
              that.nopczldata = res.data
            } else {
              that.nopczldata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getnewclickcount() {
        var pxstr = 'asc'
        if (that.px) {
          pxstr = 'asc'
        } else {
          pxstr = 'desc'
        }
        var startdate = ''
        if (that.byorderdate[0] !== '') {
          startdate = that.byorderdate[0]
        }
        var enddate = ''
        if (that.byorderdate[1] !== '') {
          enddate = that.byorderdate[1]
        }
        var qdinfo = ''
        if (that.qdinfo !== '') {
          qdinfo = that.qdinfo
        }
        var qdata = {
          pid: that.gginfo,
          cid: qdinfo,
          px: pxstr,
          startdate: startdate,
          enddate: enddate
        }
        that.clickcount = '查询中，请稍等'
        that.$http({
          url: 'http://api.jiyuewuxian.cn/getnewdjcount',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.status === 200) {
              that.clickcount = res.data
              window.console.log(that.hdcount)
              window.console.log(that.clickcount[0].总数)
              that.jhbl = (parseInt(that.hdcount) / parseInt(that.clickcount[0].总数)).toFixed(2)
            } else {
              that.clickcount = '查询失败'
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gg/GetCAndC.vue